import { FormArray, FormGroup, ValidatorFn } from '@angular/forms';

export class FormValidators {

  

  static matchFields(group: FormGroup) {

    let valid = true;
    let currValue = null;

    for (let key in group.controls) {
      if (currValue === null) currValue = group.controls[key].value;
      else {
        valid = (group.controls[key].value === currValue);
      }
    }

    if (valid) return null;

    return {
      matchFields: true
    }

  }

  static minEnabled(minEnabled: Number = 1): ValidatorFn {

    return (formArray: FormArray): any => {
      let numEnabled = (formArray.value.filter(value => value)).length;
      if (numEnabled >= minEnabled) return null;

      return {
        minEnabled: {
          actualEnabled: numEnabled,
          requiredEnabled: minEnabled
        }
      };
    };

  }

  static maxEnabled(maxEnabled: Number = 1): ValidatorFn {

    return (formArray: FormArray): any => {
      let numEnabled = 0;

      if (formArray.value) {
        numEnabled = (formArray.value.filter(value => value)).length;
      }
      if (numEnabled <= maxEnabled) return null;

      return {
        maxEnabled: {
          actualEnabled: numEnabled,
          requiredEnabled: maxEnabled
        }
      };
    };

  }
}



// WEBPACK FOOTER //
// ./src/form/form.validators.ts